import { useState } from 'react';
import { format } from 'date-fns';
import Proptypes from 'prop-types';
import FileDownload from 'js-file-download';
import { Autocomplete, Box, CircularProgress, TextField } from '@mui/material';
import { LoadingButton } from '@mui/lab';

import { api as stockApi } from '../../store/domains/stock';
import { useAutoCompleteState } from '../../hooks/useAutoCompleteState';
import Render from '../Render';

const IccidFormText = ({ handleClose, hubId, isTransfer, isUnassign }) => {
  const [mutation, { isLoading }] = stockApi.usePostAssignIccidWithList();
  const [unassignMutation, { isLoading: unassignLoading }] = stockApi.usePostUnassignIccidWithList();
  const [mutationTransfer, { isLoading: isLoadingTransfer }] = stockApi.usePostAssignIccidWithListTransfer();

  const { data: posManagerOrganizations, isLoading: posManagerLoading } = stockApi.useGetPosManagerOrganizations(
    hubId,
    {
      skip: !hubId,
    }
  );
  const { data: posManagerPartners, isLoading: posManagerOrganizationsLoading } = stockApi.useGetOrganizations(null, {
    skip: !isTransfer,
  });
  const [partnerId, handleChange] = useAutoCompleteState(isTransfer);
  const [toPartner, handleChangeToPartner] = useAutoCompleteState(isTransfer);
  const [text, setText] = useState();

  const onSubmit = () => {
    const identifiers = text?.split('\n');

    if (isTransfer) {
      const data = {
        identifiers,
        fromPartner: partnerId,
        toPartner,
      };
      mutationTransfer(data)
        .unwrap()
        .then((response) => {
          const date = format(new Date(), 'yyyy-MM-dd-HH-mm-ss');
          FileDownload(response, `IccidTransfertResult-${date}.xlsx`);
        })
        .finally(() => {
          handleClose();
        });
      return;
    }
    if (isUnassign) {
      const data = { identifiers };

      unassignMutation(data)
        .unwrap()
        .then((response) => {
          const date = format(new Date(), 'yyyy-MM-dd-HH-mm-ss');
          FileDownload(response, `IccidUnassigmentResult-${date}.xlsx`);
        })
        .finally(() => {
          handleClose();
        });
      return;
    }

    const data = {
      body: { identifiers },
      partnerId,
    };
    mutation(data)
      .unwrap()
      .finally(() => {
        handleClose();
      });
  };
  if (posManagerLoading || posManagerOrganizationsLoading || isLoading || isLoadingTransfer) {
    return <CircularProgress />;
  }

  return (
    <Box paddingTop={4}>
      <Render shouldRender={!isUnassign}>
        <Autocomplete
          value={partnerId}
          onChange={handleChange}
          options={posManagerOrganizations || []}
          renderInput={(params) => <TextField {...params} label="Select Partner" />}
          fullWidth
        />
      </Render>
      <Render shouldRender={isTransfer}>
        <Autocomplete
          value={toPartner}
          onChange={handleChangeToPartner}
          options={posManagerPartners || []}
          renderInput={(params) => <TextField {...params} label="Select Partner to transfer" />}
          fullWidth
          sx={{ mt: 2 }}
        />
      </Render>
      <Box display="flex" alignItems="center" marginTop={3}>
        <TextField
          fullWidth
          label="Write..."
          multiline
          rows={4}
          value={text}
          onChange={(e) => setText(e.target.value)}
        />
      </Box>

      <LoadingButton
        loading={isLoading || unassignLoading}
        disabled={isLoading || unassignLoading || !text || (!partnerId && !isUnassign)}
        onClick={onSubmit}
        sx={{ my: 2 }}
        fullWidth
        size="large"
        type="submit"
        variant="contained"
      >
        Submit
      </LoadingButton>
    </Box>
  );
};

IccidFormText.propTypes = {
  handleClose: Proptypes.func,
  hubId: Proptypes.number,
  isTransfer: Proptypes.bool,
  isUnassign: Proptypes.bool,
};
export default IccidFormText;
